import { render, staticRenderFns } from "./vip-favi-list.vue?vue&type=template&id=0d07fb8a&scoped=true&"
import script from "./vip-favi-list.vue?vue&type=script&lang=js&"
export * from "./vip-favi-list.vue?vue&type=script&lang=js&"
import style0 from "./vip-favi-list.vue?vue&type=style&index=0&id=0d07fb8a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d07fb8a",
  null
  
)

export default component.exports